import { useFormik } from 'formik'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup';
import { useTokenCallback } from '../../../../utils/hooks/useTokenCallback'
import { SeeCategories } from '../../../actions/pCategoriesActions'
import { createProduct, SeeProductsPresentations } from '../../../actions/productActions'
import { SeeSubCategories, SeeSubCategoriesById } from '../../../actions/subCategoriesActions'
import ProductCreate from '../../../containers/Inventory/Products/ProductCreate/ProductCreate'
const ProducsCreate = ({history}) => {
    const dispatch = useDispatch()
    const { presentations } = useSelector(state => state.productsList)
    const { isLoadingCategoriesList, categoriesList } = useSelector(state => state.categoriesAdmin)
    const { isLoadingSubCategoriesList, subCategoriesList } = useSelector(state => state.subCategoriesAdmin)

    const validationSchema = Yup.object().shape({
        image: Yup.mixed().test("fileSize", "Requerido", (value) => {
            if(value && value.type){
                return value.type.includes('image')
            }else{
                return false;
            }
            
          }),
        code: Yup.string().required('Requerido'),
        name: Yup.string().required('Requerido'),
        categoryId: Yup.string().required('Requerido'),
        subcategoryId: Yup.string().required('Requerido'),
        description: Yup.string().required('Requerido'),
        instructions: Yup.string().required('Requerido'),
        ingredients: Yup.string().required('Requerido'),
        productsize: Yup.string().required('Requerido'),
        presentationId: Yup.string().required('Requerido'),
        price: Yup.number().positive("no puede ser negativo").required('Requerido'),
        productCost: Yup.number().positive("no puede ser negativo").required('Requerido'),
      });
      
    const formik = useFormik({
        initialValues: {
            image:"",
            code: "",
            categoryId: "",
            subcategoryId: "",
            name: '',
            description: "",
            instructions: "",
            ingredients: "",
            productsize: "",
            price: "",
            productCost: "",
            presentationId:""
        },
        validationSchema:validationSchema,
        onSubmit:(values=>{
            const formData = new FormData()
            for (var key in values) {
                if (key === "image" && values[key] === "") {

                } else {
                    formData.append(key, values[key]);
                }
            }
            
            dispatch(createProduct(formData,history))
            
        })
    })
    useTokenCallback(() => {
        dispatch(SeeCategories())
        dispatch(SeeProductsPresentations())
    }, [])
    
    useTokenCallback(() => {
        dispatch(SeeSubCategoriesById(formik.values.categoryId))
    }, [formik.values.categoryId])
    return (
        <ProductCreate formik={formik} categories={categoriesList}  subCategories ={subCategoriesList}  presentations={presentations} />
    )
}

export default ProducsCreate